import { gql } from 'urql';

export const UPSERT_MASTER_HOMEPAGE = gql`
  mutation upsertMasterHomepage($input: UpsertMasterHomepageInput!) {
    upsertMasterHomepage(input: $input) {
      masterHomepage {
        id
        name
        startDate
        endDate
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DUPLICATE_MASTER_HOMEPAGE = gql`
  mutation duplicateMasterHomepage($input: DuplicateMasterHomepageInput!) {
    duplicateMasterHomepage(input: $input) {
      masterHomepage {
        id
        name
        startDate
        endDate
      }
      errors {
        field
        message
      }
    }
  }
`;

export const DELETE_MASTER_HOMEPAGE = gql`
  mutation deleteMasterHomepage($input: DeleteMasterHomepageInput!) {
    deleteMasterHomepage(input: $input) {
      errors {
        field
        message
      }
    }
  }
`;

export const SAVE_MASTER_HOMEPAGE_ROWS = gql`
  mutation saveMasterHomepageRows($input: SaveMasterHomepageRowsInput!) {
    saveMasterHomepageRows(input: $input) {
      errors {
        field
        message
      }
    }
  }
`;

export const CREATE_BRAND = gql`
  mutation CreateItemBrand($input: ItemBrandCreateInput!) {
    createItemBrand(input: $input) {
      created
      errors {
        message
      }
      itemBrand {
        id
        name
      }
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation DeleteItemBrand($input: ItemBrandDeleteInput!) {
    deleteItemBrand(input: $input) {
      errors {
        message
      }
    }
  }
`;

export const UPDATE_BRAND = gql`
  mutation UpdateItemBrand($input: ItemBrandUpdateInput!) {
    updateItemBrand(input: $input) {
      errors {
        message
      }
      itemBrand {
        id
        name
      }
    }
  }
`;

export const CREATE_INVENTORY_ITEM = gql`
  mutation CreateInventoryItem($item: InventoryItemInput!) {
    createInventoryItem(item: $item) {
      id
      name
    }
  }
`;

export const CREATE_NON_INVENTORY_ITEM = gql`
  mutation CreateNonInventoryItem($item: NonInventoryItemInput!) {
    createNonInventoryItem(item: $item) {
      id
      name
    }
  }
`;

export const DISCONTINUE_ITEM = gql`
  mutation DiscontinueItem($id: ID!, $input: [DiscontinueWarehouseInput]!) {
    discontinueWarehouseItem(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const SET_ITEM_INACTIVE = gql`
  mutation SetItemInactive($id: ID!, $inactive: Boolean!) {
    setItemInactive(id: $id, inactive: $inactive) {
      item {
        id
        inactivatedOn
      }
      errors {
        message
      }
    }
  }
`;

export const IMPORT_PRICING_RULES = gql`
  mutation ImportPriceRulesCsv($input: ImportPriceRulesCsvInput!) {
    importPriceRulesCsv(input: $input) {
      clientMutationId
      errors
    }
  }
`;

export const IMPORT_PROCUREMENT_RECORDS = gql`
  mutation ImportProcurementRecords($input: [ImportProcurementInput!]!) {
    importProcurementRecords(input: $input)
  }
`;

export const UPDATE_INVENTORY_ITEM = gql`
  mutation UpdateInventoryItem($id: ID!, $item: InventoryItemInput!) {
    updateInventoryItem(id: $id, item: $item) {
      id
      name
      imgUrl
    }
  }
`;

export const UPDATE_NON_INVENTORY_ITEM = gql`
  mutation UpdateNonInventoryItem($id: ID!, $item: NonInventoryItemInput!) {
    updateNonInventoryItem(id: $id, item: $item) {
      id
      name
      imgUrl
    }
  }
`;

export const UPSERT_LOCATION_ITEM = gql`
  mutation UpsertLocationItem($input: LocationItemInput!) {
    upsertLocationItem(input: $input) {
      locationId
      itemId
    }
  }
`;

export const REMOVE_LOCATION_ITEM = gql`
  mutation RemoveLocationItem($input: LocationItemInput!) {
    removeLocationItem(input: $input)
  }
`;

export const UPDATE_ITEM_PRICES = gql`
  mutation UpdateItemPrices($input: UpdateItemPricesInput!) {
    updateItemPrices(input: $input) {
      result {
        ... on ItemPricesSuccess {
          updatedItemsCount
          updatedWarehouseItemsCount
        }
        ... on ErrorsResult {
          errors {
            head {
              message
            }
            tail {
              message
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_WAREHOUSE_LEAD_TIME = gql`
  mutation UpdateWarehousesLeadTime(
    $input: UpdateWarehousesLeadTimeMutationInput!
  ) {
    updateWarehousesLeadTime(input: $input) {
      clientMutationId
    }
  }
`;

export const GENERATE_ITEM_DESCRIPTION = gql`
  mutation GenerateItemDescription($input: GenerateItemDescriptionInput!) {
    generateItemDescription(input: $input) {
      success
      description
      message
    }
  }
`;

export const TRANSFORM_PRODUCT_IMAGE = gql`
  mutation TransformProductImage($input: TransformProductImageInput!) {
    transformProductImage(input: $input) {
      success
      transformedUrl
      message
    }
  }
`;

export const CREATE_HOMEPAGE_COMPONENT = gql`
  mutation CreateHomepageComponent($input: CreateHomepageComponentInput!) {
    createHomepageComponent(input: $input) {
      componentId
      componentType
      ruleId
      errors {
        message
        field
        code
      }
    }
  }
`;

export const DELETE_MASTER_HOMEPAGE_ROW_COMPONENT = gql`
  mutation DeleteMasterHomepageRowComponent(
    $input: DeleteMasterHomepageRowComponentInput!
  ) {
    deleteMasterHomepageRowComponent(input: $input) {
      errors {
        field
        message
      }
    }
  }
`;

export const CREATE_HOMEPAGE_DISPLAY_RULE = gql`
  mutation CreateHomepageDisplayRule($input: CreateHomepageDisplayRuleInput!) {
    createHomepageDisplayRule(input: $input) {
      ruleId
      errors {
        message
        field
        code
      }
    }
  }
`;

export const UPDATE_HOMEPAGE_DISPLAY_RULES = gql`
  mutation UpdateHomepageDisplayRules(
    $input: UpdateHomepageDisplayRulesInput!
  ) {
    updateHomepageDisplayRules(input: $input) {
      updatedRuleIds
      errors {
        message
        field
        code
      }
    }
  }
`;

export const DELETE_COLLECTION_PROMO_SETUP = gql`
  mutation DeleteCollectionPromoSetup(
    $input: DeleteCollectionPromoSetupInput!
  ) {
    deleteCollectionPromoSetup(input: $input) {
      errors {
        message
      }
    }
  }
`;

export const UPSERT_SUBSTITUTION_OVERRIDE = gql`
  mutation UpsertSubstitutionOverride(
    $input: UpsertSubstitutionOverrideInput!
  ) {
    upsertSubstitutionOverride(input: $input) {
      override {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const REMOVE_SUBSTITUTION_OVERRIDE = gql`
  mutation RemoveSubstitutionOverride(
    $input: RemoveSubstitutionOverrideInput!
  ) {
    removeSubstitutionOverride(input: $input) {
      override {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const UPSERT_CATEGORY_BANNER = gql`
  mutation UpsertCategoryBanner($input: UpsertCategoryBannerInput!) {
    upsertCategoryBanner(input: $input) {
      categoryBannerId
      errors {
        message
        field
        code
      }
    }
  }
`;

export const DELETE_CATEGORY_BANNER = gql`
  mutation DeleteCategoryBanner($input: DeleteCategoryBannerInput!) {
    deleteCategoryBanner(input: $input) {
      categoryBannerId
      errors {
        message
      }
    }
  }
`;
